import { css } from 'lit';

// these styles can be imported from any component
// for an example of how to use this, check /pages/about-about.ts
export const styles = css`
  main {
    display: flex;
    align-items: flex-start;
  }
  p {
  margin: 0;
  }

  ::-webkit-scrollbar{
	width: 10px;
}

::-webkit-scrollbar-track-piece{
	background-color: #181818;
}

::-webkit-scrollbar-thumb{
	background-color:rgb(15, 14, 14);
}

::-webkit-scrollbar-thumb:hover{
	background-color: #909090;
}

`;